/// Pure geometry helpers for the AltitudeRibbon component.
///
/// Both functions are stateless and DOM-free so they can be
/// unit-tested without rendering. The component layer in
/// AltitudeRibbon.tsx calls these from pointer-event handlers,
/// the wheel handler, and the numeric-input commit path.

const MIN_ALTITUDE_FT = 0
const MAX_ALTITUDE_FT = 50000

/// Snap a foot value to the nearest 100 ft, then clamp to
/// [0, 50000]. Matches the existing CommandPanel altitude
/// rounding (`Math.round(n / 100) * 100`) plus a defensive
/// range clamp. Per-aircraft min/max enforcement happens
/// downstream in `handlers.onSetAltitude`; this clamp is just
/// to keep the centered value visually sane.
export function snapToHundred(ft: number): number {
  const snapped = Math.round(ft / 100) * 100
  // Use Object.is to catch -0 (IEEE 754: -0 < 0 is false, but -0 !== +0).
  if (snapped < MIN_ALTITUDE_FT || Object.is(snapped, -0)) return MIN_ALTITUDE_FT
  if (snapped > MAX_ALTITUDE_FT) return MAX_ALTITUDE_FT
  return snapped
}

/// Convert a pixel drag-delta into the equivalent foot delta.
/// Sign-preserving: positive deltaPx returns positive feet. The
/// "drag up = altitude up" convention is applied at the call
/// site (the ribbon component subtracts this value from the
/// start target).
///
/// Returns 0 when `pxPerFoot` is 0 (defensive — avoids
/// Infinity / NaN if the tape hasn't been measured yet).
export function pixelDeltaToFeet(deltaPx: number, pxPerFoot: number): number {
  if (pxPerFoot === 0) return 0
  return deltaPx / pxPerFoot
}
